export interface FeedbackSection {
  id: string;
  type: 'header' | 'item';
  content: string;
  emoji?: string;
}
const formatFeedbackMessages = (feedback: any, t: any): FeedbackSection[] => {
  return [
    {
      id: 'overview',
      type: 'header',
      content: t('coach.chat.feedback.overview', {
        scenarioOverview: feedback.scenarioOverview,
      }),
      emoji: '🎯',
    },
    {
      id: 'strengths-header',
      type: 'header',
      content: t('coach.chat.feedback.strengths_header'),
      emoji: '💪',
    },
    ...feedback.strengths.map((strength: string, i: number) => ({
      id: `strength-${i}`,
      type: 'item',
      content: strength,
    })),
    {
      id: 'improvements-header',
      type: 'header',
      content: t('coach.chat.feedback.improvements_header'),
      emoji: '🔄',
    },
    ...feedback.areasForImprovement.map((area: string, i: number) => ({
      id: `improvement-${i}`,
      type: 'item',
      content: area,
    })),
    {
      id: 'next-steps-header',
      type: 'header',
      content: t('coach.chat.feedback.next_steps_header'),
      emoji: '👉',
    },
    ...feedback.actionableNextSteps.map((step: any, i: number) => ({
      id: `step-${i}`,
      type: 'item',
      content: step.description,
    })),
    {
      id: 'final-prompt',
      type: 'header',
      content: t('coach.chat.feedback.final_prompt'),
      emoji: '💭',
    },
  ];
};

export { formatFeedbackMessages };